import { render, staticRenderFns } from "./Bpm.vue?vue&type=template&id=65a4795f&"
import script from "./Bpm.vue?vue&type=script&lang=js&"
export * from "./Bpm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports